export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: '火影黄漫是什么？与普通火影同人有什么区别？',
    answer: '火影黄漫是指火影忍者（NARUTO）相关题材的成人向同人漫画创作。与普通火影同人漫画的区别在于，黄漫包含成人向内容（R18），通常涉及更为成熟的角色关系描绘与情节设定。这类作品是火影同人创作生态中的重要组成部分，在全球拥有大量爱好者。需要强调的是，同人创作应尊重原作版权，合理界定创作边界。',
  },
  {
    question: '在哪里可以找到高质量的火影成人向同人漫画？',
    answer: '主要有以下几个渠道：1）Pixiv（全球最大的同人创作平台，使用日文标签搜索效果最佳）；2）Fantia / Fanbox（绘师付费订阅平台）；3）DLsite（同人作品电子版贩售平台）；4）Archive of Our Own / AO3（国际同人文与漫画平台）；5）Comiket等线下展会。建议优先使用Pixiv，标签体系最为完善。本站资源导航板块提供了详细的各平台使用指南。',
  },
  {
    question: '如何成为一名火影同人绘师？需要具备哪些技能？',
    answer: '成为火影同人绘师需要：1）扎实的绘画基本功（人体结构、透视、动态）；2）掌握数字绘画软件（CLIP STUDIO PAINT是最常用的漫画创作工具）；3）了解日式漫画的分镜语法；4）熟悉火影忍者的角色设定与世界观。本站创作技巧板块提供了从零开始的系统教程。',
  },
  {
    question: '火影同人创作涉及版权问题吗？如何规避风险？',
    answer: '同人创作在全球范围内处于灰色地带。在日本，同人创作属于"黙認"（默许）范畴，原作者通常不会追究。但需注意：1）不要直接复制原作画面；2）不要使用官方Logo或商标；3）标注二次创作声明；4）如收到版权方警告，应立即下架相关作品。本站建议所有创作者尊重原作版权，在合理范围内进行创作表达。',
  },
  {
    question: '如何支持喜欢的火影同人绘师？',
    answer: '支持绘师的方式包括：1）在Fantia/Fanbox订阅绘师的付费频道；2）在DLsite/Booth购买电子版或实体同人志；3）通过Skeb向绘师约稿；4）在Pixiv点赞、收藏和转发作品；5）在社交媒体上分享绘师的作品（需注明出处）。金钱支持能让绘师有更多时间投入创作，免费互动同样是最直接的鼓励。',
  },
  {
    question: '本站推荐的火影同人内容是否经过筛选？',
    answer: '本站导航的内容均为用户自主创作的同人作品，我们提供的是平台入口和搜索指南，而非直接的内容分发。我们建议所有访问者：1）确认自己已满18周岁再浏览成人向内容；2）遵守各平台的使用条款和内容规范；3）理性看待同人创作，区分创作与现实的边界。本站致力于为火影同人爱好者提供安全、便捷的导航服务。',
  },
];